import i18n from '@/langs/i18n.js';

export default [
  {
    text: i18n.t('installmentTypes.equal'),
    value: 'EQUAL'
  },
  {
    text: i18n.t('installmentTypes.diminish'),
    value: 'DIMINISH'
  }
]
